import React from "react";

import { CheckIcon } from "@/Components/Icons/CheckIcon";

import { CandidatePayInvoiceStatusList } from "../../../../Constants/filterConstants";

/**
 * Function for rendering the Invoice Status component.
 *
 * @param {object} active - the active status
 * @param {function} handleClick - the click event handler
 * @return {JSX} the rendered Invoice Status component
 */
const InvoiceStatus = ({ active, handleClick }) => {
  // console.log("active", active)

  const handleItemClick = (value) => {
    handleClick(
      active.includes(value)
        ? active.filter((item) => item !== value)
        : [...active, value],
    );
  };

  return (
    <div className="SessionTypeFilter_Wrapper">
      <div className="grid gap-3">
        <label className="label text-black" htmlFor="invoiceStatus">
          Invoice Status
        </label>
        <div className="flex gap-4">
          {CandidatePayInvoiceStatusList.map((item, index) => {
            return (
              <div
                key={index}
                className={`ease flex cursor-pointer items-center gap-2 rounded-lg px-4 py-2 transition-all duration-300 ${
                  active.includes(item.value)
                    ? "bg-primary text-white"
                    : "bg-grey text-txtColor hover:bg-lightblue"
                }`}
                onClick={() => {
                  handleItemClick(item.value);
                  // single selection
                  // if (active.includes(item.value)) {
                  // handleClick([])
                  // } else {
                  //   handleClick([item.value])
                  // }
                }}
              >
                <span
                  className={`block overflow-hidden !text-white transition-all duration-300 ${
                    active.includes(item.value) ? "w-[14px]" : "-me-2 w-0"
                  }`}
                >
                  <CheckIcon />
                </span>
                <span className="text-[14px]">{item.name}</span>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default InvoiceStatus;
